import { useAuth } from "@/features/auth/contexts/AuthContext";
import { Button } from "@shared/components/ui/button";
import { PlusIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AddNewPickup = () => {
  const { t } = useTranslation();
  const { isCollector } = useAuth();
  return (
    <div>
      {!isCollector && (
        <Link to="/pickups/create">
          <Button className="flex gap-2">
            <PlusIcon />
            {t("pickups.addPickup")}
          </Button>
        </Link>
      )}
    </div>
  );
};

export default AddNewPickup;
